import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-sets <link rel="canonical"> and og:url on every route change so each
 * SPA page reports its own canonical URL to Google (fixes the "duplicate
 * canonical" Search Console warning).
 *
 * Skips /admin/* (private).
 */
export default function CanonicalHandler() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    if (location.pathname.startsWith("/espace")) return;
    const base = "https://lesrdvdelecriture.com";
    // Table de correspondance URL vers canonique — utile pour les vieilles
    // URLs préservées (mêmes contenu que la nouvelle URL) qui ne doivent
    // plus être indexées comme distinctes.
    const CANONICAL_MAP = {
      "/atelier": "/ateliers",
    };
    // Strip trailing slash except for root
    let path = location.pathname === "/" ? "/" : location.pathname.replace(/\/+$/, "");
    if (CANONICAL_MAP[path]) path = CANONICAL_MAP[path];
    const href = base + path;

    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      document.head.appendChild(el);
    }
    el.setAttribute("href", href);

    let og = document.head.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", href);
  }, [location.pathname]);
  return null;
}
